import { nextTick, useNuxtApp, useState } from "#imports";
export function useChat() {
  const { $chat } = useNuxtApp();
  const isSending = useState("isSending", () => false);
  const isConnected = useState("isConnected", () => false);
  const messages = useState("messages", () => []);
  const channelType = useState("channelType", () => "");
  const channelId = useState("channelId", () => "");
  const connectWithProvider = async (tokenProvider) => {
    try {
      const { user, token, name, channelType: userChannelType, channelId: userChannelId } = await tokenProvider();
      channelType.value = userChannelType;
      channelId.value = userChannelId;
      await $chat.connect(user, token, name);
      await $chat.setConversation(userChannelType, userChannelId);
      messages.value = $chat.getMessages();
      $chat.onMessageReceived(receiveMessage);
      isConnected.value = true;
    } catch (error) {
      console.error("Chat connection failed:", error);
      isConnected.value = false;
      throw error;
    }
  };
  function receiveMessage(message) {
    const index = messages.value.findIndex((m) => m.id === message.id);
    if (index !== -1) {
      messages.value[index] = message;
    } else {
      messages.value.push(message);
    }
    if (message.user?.id.includes("ai_agent")) {
      isSending.value = false;
      const chatInput = document.querySelector(`#ai-chat-input-${channelId.value}`);
      nextTick(() => {
        chatInput?.focus?.();
      });
    }
  }
  async function sendMessage(text, customData = {}) {
    if (!text.trim()) {
      throw new Error("Message cannot be empty");
    }
    if (!isConnected.value) {
      throw new Error("Chat is not connected, sendMessage failed");
    }
    isSending.value = true;
    try {
      await $chat.sendMessage(text, customData);
    } catch (error) {
      console.error("Error sending message:", error);
      isSending.value = false;
      throw error;
    }
  }
  async function disconnect() {
    if (isConnected.value) {
      try {
        await $chat.disconnect();
        isConnected.value = false;
        messages.value = [];
        channelType.value = "";
        channelId.value = "";
      } catch (error) {
        console.error("Error during disconnect:", error);
      }
    }
  }
  return {
    messages,
    isConnected,
    isSending,
    channelType,
    channelId,
    connectWithProvider,
    sendMessage,
    disconnect
  };
}
